import {
  CreateSubscription,
  CreateToken,
  UpdateInvoiceDetails,
  UpdatePaymentMethod,
  UpdateSubscription,
} from '../models/api';
import { httpGet, httpPost } from 'core/utils/httpClient';
import { Subscription } from '../models/subscription';

export const createToken = (data: CreateToken) => httpGet('payments/create-token', data);

export const createSubscriptionEstimate = (frequency: number, coupon: string) =>
  httpGet('payments/create-subscription-estimate', { frequency, coupon });

export const createSubscription = (data: CreateSubscription) =>
  httpPost('payments/create-subscription', data);

export const getSubscription = () =>
  new Promise<Subscription>((resolve) => {
    httpGet('payments/get-subscription').then((res) => {
      resolve({
        ...res,
        created: res.created && (Number.isNaN(res.created) ? res.created : new Date(res.created)),
        start: res.start && (Number.isNaN(res.start) ? res.start : new Date(res.start)),
        end: res.end && (Number.isNaN(res.end) ? res.end : new Date(res.end)),
        exp:
          res.expiration &&
          (Number.isNaN(res.expiration) ? res.expiration : new Date(res.expiration)),
        resumes_on:
          res.resumes_on &&
          (Number.isNaN(res.resumes_on) ? res.resumes_on : new Date(res.resumes_on)),
      });
    });
  });

export const getCustomer = () => httpGet('payments/get-customer');

export const reactivateSubscription = () => httpGet('payments/reactivate-subscription');

export const cancelSubscription = (cancel_immediately: boolean) =>
  httpPost('payments/cancel-subscription', { cancel_immediately });

export const pauseSubscription = (duration: number) =>
  httpGet('payments/pause-subscription', { pause_for: duration });

export const resumeSubscription = () => httpGet('payments/resume-subscription');

export const updateSubscription = (data: UpdateSubscription) =>
  httpPost('payments/update-subscription', data);

export const updateSubscriptionEstimate = (data: { frequency: number }) =>
  httpGet('payments/update-subscription-estimate', data);

export const getInvoices = () => httpGet('payments/get-invoices');

export const downloadInvoice = (invoice_id: string) =>
  httpGet('payments/download-invoice', { invoice_id });

export const updatePaymentMethod = (data: UpdatePaymentMethod) =>
  httpPost('payments/update-payment-method', data);

export const getHostedPage = (email: string, frequency: number, coupon?: string) =>
  httpPost('payments/create-checkout-session', {
    email,
    frequency,
    coupon,
  });

export const getPortalSession = () => httpPost('payments/create-portal-session', {});

export const checkCard = (token: string, provider: string) =>
  httpPost('payments/check-card', { token, provider });

export const updateInvoiceDetails = (data: UpdateInvoiceDetails) =>
  httpPost('payments/update-invoice-details', data);
